import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    vendorList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },

    vendorDetails: {
        requesting: false,
        data: null,
        error: null,
        success: false,
    },
}

export const vendorSlice = createSlice({
    name: 'vendor',

    initialState,

    reducers: {

        getVendorList: (state, action) => {
            state.vendorList.requesting = true
            state.vendorList.error = null
            state.vendorList.items = []
            state.vendorList.success = false
            state.vendorList.filters = action.payload
        },

        getVendorListSuccess: (state, action) => {

            const {
                data,
                current_page,
                per_page,
                total
            } = action.payload

            state.vendorList.requesting = false
            state.vendorList.items = data
            state.vendorList.success = true

            state.vendorList.pagination.current_page = current_page
            state.vendorList.pagination.per_page = per_page
            state.vendorList.pagination.total = total
        },

        getVendorListFail: (state, action) => {
            state.vendorList.requesting = false
            state.vendorList.error = action.payload
        },


        getVendorDetails: (state) => {
            state.vendorDetails.requesting = true
            state.vendorDetails.error = null
            state.vendorDetails.data = null
            state.vendorDetails.success = false
        },

        getVendorDetailsSuccess: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.data = action.payload
            state.vendorDetails.success = true
        },

        getVendorDetailsFail: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.error = action.payload
        },


        doVendorCreate: (state) => {
            state.vendorDetails.requesting = true
            state.vendorDetails.error = null
            state.vendorDetails.data = null
            state.vendorDetails.success = false
        },

        doVendorCreateSuccess: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.data = action.payload
            state.vendorDetails.success = true
        },

        doVendorCreateFail: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.error = action.payload
            state.vendorDetails.success = false
        },


        doVendorUpdate: (state) => {
            state.vendorDetails.requesting = true
            state.vendorDetails.error = null
            state.vendorDetails.data = null
            state.vendorDetails.success = false
        },

        doVendorUpdateSuccess: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.data = action.payload
            state.vendorDetails.success = true
        },

        doVendorUpdateFail: (state, action) => {
            state.vendorDetails.requesting = false
            state.vendorDetails.error = action.payload
            state.vendorDetails.success = false
        },


        doVendorDelete: (state) => {
            state.vendorDetails.requesting = true
            state.vendorDetails.error = null
            state.vendorDetails.data = null
            state.vendorDetails.success = false
        },


        doVendorReset: (state) => {
            state.vendorDetails.data = null
        },

    },
})

export const {

    getVendorList, getVendorListSuccess,
    getVendorListFail, getVendorDetails,
    getVendorDetailsSuccess, getVendorDetailsFail,
    doVendorCreate, doVendorCreateSuccess,
    doVendorCreateFail, doVendorUpdate,
    doVendorUpdateSuccess, doVendorUpdateFail,
    doVendorDelete, doVendorReset,

} = vendorSlice.actions

export default vendorSlice.reducer